import { Avatar as BaseAvatar } from "@base-ui/react/avatar";
import * as stylex from "@stylexjs/stylex";
import "../tokens.stylex.ts";
import { color, fontWeight, radius } from "../tokens.stylex.ts";
function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const letters = parts.length > 1 ? `${parts[0]?.[0] ?? ""}${parts.at(-1)?.[0] ?? ""}` : (parts[0] ?? "?").slice(0, 2);
  return letters.toUpperCase();
}
export function Avatar({
  name,
  src,
  size = 24,
  square = false
}: {
  name: string;
  src?: string | null;
  size?: number;
  /** Squared corners for organizations/apps; round for people. */
  square?: boolean;
}) {
  return <BaseAvatar.Root {...stylex.props(styles.root, square ? styles.square : styles.round, styles.size(size))}>
      {src ? <BaseAvatar.Image src={src} alt="" className="xh8yej3 x5yr21d xl1xv1r" /> : null}
      <BaseAvatar.Fallback className="x1ivwu1z xo5v014">{initials(name)}</BaseAvatar.Fallback>
    </BaseAvatar.Root>;
}
const styles = {
  root: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kmuXW: "x2lah0s",
    kVQacm: "xb3r6kr",
    kWkggS: "xyez3s8",
    kMwMTN: "x187ovcu",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8nrc2f",
    kfSwDN: "x87ps6o",
    $$css: true
  },
  round: {
    kaIpWk: "x257jf6",
    $$css: true
  },
  square: {
    kaIpWk: "xoazux2",
    $$css: true
  },
  size: (size: number) => [{
    kzqmXN: size != null ? "x5lhr3w" : size,
    kZKoxP: size != null ? "x16ye13r" : size,
    kGuDYH: Math.max(9, Math.round(size * 0.4)) != null ? "xdmh292" : Math.max(9, Math.round(size * 0.4)),
    $$css: true
  }, {
    "--x-width": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(size),
    "--x-height": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(size),
    "--x-fontSize": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(Math.max(9, Math.round(size * 0.4)))
  }]
};